import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { fetchCoctails, getCoctailsList } from '../../store/coctailsSlice';

const useCoctails = () => {
  const dispatch = useAppDispatch();
  const { coctails } = getCoctailsList(useAppSelector(state => state.coctailsReducer));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchCoctails({}));
    setLoading(false);
  }, []);

  return { coctails, loading };
};

export default useCoctails;
